import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { GoalsPageList } from './GoalsPageList';
import {
    getHeaderNames,
    getRegions,
    getGoalEntries
} from './GoalsPageList.selectors';

const mapStateToPropsSelectors = createStructuredSelector({
    headerNames: getHeaderNames,
    regions: getRegions,
    goalEntries: getGoalEntries
});

const GoalsPageListComponent = connect(
    function mapStateToProps(state) {
        return {
            ...mapStateToPropsSelectors(state),
            loading: state.goalEntries.loading,
            totalPages: state.goalEntries.total
        };
    },
    function mapDispatchToProps(dispatch) {
        return {};
    }
)(GoalsPageList);

export default GoalsPageListComponent;
